<template>
		<signUpForMobile  v-if="isMobile" v-bind:isVisible="isChildVisible" @visibility-changed="handleVisibilityChange" style="position:fixed;top: 10vh; left:17.5vw;width: 50vw;height:25vh; background-color: black; z-index: 20;">
		</signUpForMobile>
		<signUP v-else v-bind:isVisible="isChildVisible" @visibility-changed="handleVisibilityChange" style="position:fixed;top: 6vw; left:27vw;height:50vh; background-color: rgba(255, 0, 0, 0);; z-index: 20;">
		</signUP>
    <div style="position: fixed; top: 0; display: flex; flex-direction: row-reverse; width: 100%; height: 5.6316vw; background-color: black; z-index: 100;">
			<div style="width: 8%; display: flex; justify-content: space-between; align-items: center;margin-right: 10%;">
				<!-- <img :src="iconDict.searchIcon" alt="123"  style="width: 1.6vw; object-fit: contain;"> -->
				<!-- <div class="text-logo" >
  				<div class="left" @click="gotoPage(headRight[0].url)">{{ headRight[0].name }}</div>
  				<em class="divider"></em>
 				 <div class="right" @click="gotoPage(headRight[1].url)">{{headRight[1].name}}</div>
</div> -->

				<!-- <img :src="iconDict.more_icon" alt="" style="width: 1.6vw; object-fit: contain;"> -->
			</div>
			
			<div style=" height:100%;width: 57%; display: flex; justify-content: flex-start; align-items: center; position: absolute; left: 30%; " v-if="headInfo.length > 0">
				<a style="margin-left: 1.5vw;" v-for="(item,index) in headInfo" :key="index" :class="{ active: activeRoute === (item.url ? item.url.slice(1) : '') }" :href="`/#/${item.url ? item.url.slice(1) : ''}`"> <p>     {{ item.name }}     </p></a>
				<!-- <a v-for="(item,index) in headInfo" :key="index" :class="{ active: activeRoute === (item.url ? item.url.slice(1) : '') }" :href="`/#/${item.url ? item.url.slice(1) : ''}`"> <p>     {{ item.name }}     </p></a> -->
				<!-- <a :class="{ active: activeRoute === 'comprehensive' }" href="#/comprehensive">         <p>课程</p></a>
				<a  :class="{ active: activeRoute === 'casePage' }" href="#/case">          <p>案例</p></a>
				<a :class="{ active: activeRoute === 'Community' }" href="#/Community">     <p>社区</p></a>
				<a :class="{ active: activeRoute === 'servicePage' }" href="#/service">       <p>服务</p></a>
				<a :class="{ active: activeRoute === 'realTimeInfo' }" href="#/Information">   <p>资讯</p></a>
				<a :class="{ active: activeRoute === 'cooperation' }" href="#/cooperation"> <p>合作</p></a>
				<a :class="{ active: activeRoute === 'FAQ' }" href="#/FAQ">           <p>常见问题</p></a> -->
				
			</div>
			
		</div>
		
		<router-link to="/home">
		<div style="position: fixed; top: 0; background-color: black; width: 25%; height: 8vw; display: flex; align-items: center; z-index: 100;">
				<img src="/img/logo.png" alt="" style="width:10vw; height: 10VW;">
				<!-- <p style="color:white; font-size: 2vw; font-family: 'WRYH'; margin: 0; margin-left: -2VW;">Unity 集训营</p> -->
				 <div style="margin-left: -2vw;">
				 <p v-html="html"></p>
				</div>
		</div>
		
	</router-link>
	
</template>
<script>
import {request} from '@/Common/request/request';
import signUP from './signUp.vue'
import signUpForMobile from './signUpForMobile.vue';
export default {
	name: 'pageHead',


	data() {
		return {
			isMobile: false,
			html:"",
			activeRoute: '',
			isChildVisible:false,
			iconDict: {searchIcon:"",mail_list_icon:"",more_icon:"",logo:""},
			testurl:"http://39.105.131.120:8000/uploads/11.png",
			headInfo:[],
			headRight:[{},{}],
		}
	},
	components:{
        signUP,
		signUpForMobile
    },
	methods:{
		gotoPage(path) {
            if(path=="" || path==null){
                return
            }
      // 直接通过路径跳转
      this.$router.push(path);

    },
		detectDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // 判断是否为移动设备
      const mobileKeywords = [
        'Android', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'Windows Phone',
        'Opera Mini', 'IEMobile', 'Mobile', 'Tablet'
      ];

      for (let i = 0; i < mobileKeywords.length; i++) {
        if (userAgent.indexOf(mobileKeywords[i]) > 0) {
          this.isMobile = true;
          return;
        }
      }

      this.isMobile = false;
    },
		replacePxValues(str, multiplier) {
    // 正则表达式匹配数字加px的模式，并捕获数字部分
    const regex = /(\d+)(px)/g;
    return str.replace(regex, (match, numberStr, px) => {
        // 将捕获到的数字字符串转换为数字，乘以给定的乘数，然后再转回字符串
        const newNumber = parseInt(numberStr, 10) * multiplier;
        // 返回替换后的字符串，即新数字加px
        return newNumber + px;
    });
},
	toggleVisibility() {
      this.isChildVisible = !this.isChildVisible;
    },
    handleVisibilityChange(isVisible) {
      this.isChildVisible = isVisible;
    },
	updateActiveRoute() {
           // 假设你的路由配置中有name属性
           this.activeRoute = this.$route.name;
		   console.log(this.activeRoute)
         }



	},
	watch: {
         '$route': function(to, from) {
           this.updateActiveRoute();
         }
       },
	created() {
    this.detectDevice();
  },
	mounted() {
    this.updateActiveRoute();
	let that = this
	request('title').then(res => {
    console.log(res)
	
	that.html = that.replacePxValues(res.data[0].text,0.05)
	that.html=that.html.replace(/px/g, 'vw');
}).then(err => {
    console.log(err)
})
		
       },

	beforeCreate() {

    request("iconApi/icon").then(res => {
		for(let i = 0; i < res.data.length; i++){
			switch(res.data[i].unique_identifier){
				case "global_search_icon":
					this.iconDict.searchIcon = res.data[i].image_url
					break
				case "global_mail_list_icon":
					this.iconDict.mail_list_icon = res.data[i].image_url
					break
				case "global_more_icon":
					this.iconDict.more_icon = res.data[i].image_url
					break
				case "homePageLogo":
					this.iconDict.logo = res.data[i].image_url
					break
			}
		}
		
	  console.log(res.data)
		}).catch(err => {
			console.log(err)
      alert("请求失败")
		})
	request("topView?ordering=order").then(res=>{
		for(let i = 0; i < res.data.length; i++){
			if(i<res.data.length){
				this.headInfo.push({
					name:res.data[i].name,
					url:res.data[i].url
				})
			}
			else{
				this.headRight[i-res.data.length+2]=res.data[i]
			}


		}
	}).catch(err => {
		console.log(err)
      alert("请求失败")
	})
	},
	computed: {
    // dynamicFontSize(num) {
    //   // 假设你有一个方法或逻辑来判断当前的URL
    //   if(this.$route.path=="/comprehensive" && num==1){
	// 	return "1.4vw"
	//   }
	//   if(this.$route.path=="/case" && num==2){
	// 	return "1.4vw"
	//   }
	//   if(this.$route.path=="/Community" && num==3){
	// 	return "1.4vw"
	//   }
	//   if(this.$route.path=="/service" && num==4){
	// 	return "1.4vw"
	//   }
	//   if(this.$route.path=="/Information" && num==5){
	// 	return "1.4vw"
	//   }
	//   if(this.$route.path=="/cooperation" && num==6){
	// 	return "1.4vw"
	//   }
	//   if(this.$route.path=="/FAQ" && num==7){
	// 	return "1.4vw"
	//   }
	//   return "1.2vw"

    //   // 更复杂的逻辑也可以在这里实现，比如根据路径包含的关键字动态调整大小等
    // },
	// dynamicColor(num){
	// 	if(this.$route.path=="/comprehensive" && num==1){
	// 		return "lightblue"
	// 	}
	// 	if(this.$route.path=="/case" && num==2){
	// 		return "lightblue"
	// 	}
	// 	if(this.$route.path=="/Community" && num==3){
	// 		return "lightblue"
	// 	}
	// 	if(this.$route.path=="/service" && num==4){
	// 		return "lightblue"
	// 	}
	// 	if(this.$route.path=="/Information" && num==5){
	// 		return "lightblue"
	// 	}
	// 	if(this.$route.path=="/cooperation" && num==6){
	// 		return "lightblue"
	// 	}
	// 	if(this.$route.path=="/FAQ" && num==7){
	// 		return "lightblue"
	// 	}
	// 	return "white"




	// }
  }
	 

}
</script>
<style scoped>
.active >p {

	background-color: black;
    text-align: center;
    -webkit-text-stroke: 0.01vw  white;
    color: transparent; 

     }
p{
	font-size: 1.2vw;
    color: white;
    font-weight: 800;
    margin: 0;
    padding: 0;

}
.home-style {
	background-color: black;
    text-align: center;
    -webkit-text-stroke: 0.08vw white;
    color: transparent; 
}
.text-logo {
	cursor: pointer;
  display: flex;
 	flex-direction: row;
  font-size: 1.2vw;
  color: white;
  font-weight: 800;

  font-family: ALBB-puhui;
}

.left {

	padding: 0;
	width: 6vw;
	position: relative;
	top: -0.5vw;
	margin-right: -1.4vw;
}

.right {

	padding: 0;
	width: 6vw;
	position: relative;
	top: 0.5vw;
	margin-left: -1.5vw;
}

.divider {
	
  display: inline-block;
  position: relative;
  top: 0.7vw; /* 中间位置 */
  width: 2.5vw; /* 斜杠宽度 */
  height: 0.1vw; /* 斜杠高度 */
  background-color: currentColor; /* 使用当前颜色 */
  transform: rotate(-45deg); /* 旋转斜杠 */

}

</style>